(function () {
  function patchMinicartLineItem() {
    var Cls = customElements.get('minicart-line-item');
    if (!Cls || Cls.prototype.__patchedAdd) return;

    Cls.prototype.onFormChangeHandler = function () {
      var el = this.querySelector('[data-action="add"]');
      if (el) el.classList.remove('hidden');
    };
    Cls.prototype.__patchedAdd = true;
    console.log('[cart-fix] onFormChangeHandler patched');
  }

  function patchCartItemsRender() {
    var Cls = customElements.get('cart-items');
    if (!Cls || Cls.prototype.__patchedRender) return;

    Cls.prototype.renderContents = function (parsedState) {
      if (!parsedState.sections) { location.reload(true); return; }

      if (document.querySelector('body').classList.contains('header-cart-dropdown') || document.body.classList.contains('template-cart')) {
        if (window.Popup) {
          Popup.clearQuickViewCache && Popup.clearQuickViewCache();
          Popup.closePopupExeptCart && Popup.closePopupExeptCart();
        }
      }

      document.querySelectorAll('mini-cart-popup').forEach(function (el) {
        el.removeCarousel && el.removeCarousel();
      });

      var self = this;
      this.getSectionsToRender().forEach(function (section) {
        if (!(section.render_on_cart_page_only && !self.onCartPage) || (section.not_render_on_cart_page_only && !self.onCartPage)) {
          if (section.bubble) {
            document.querySelectorAll(section.selector).forEach(function (dest) {
              try {
                dest.innerHTML = self.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
              } catch (e) {}
            });
          } else {
            document.querySelectorAll('[id="' + section.id + '"]').forEach(function (destination) {
              var selector = section.selector;
              if (selector) {
                var inner = destination.querySelector(selector);
                if (inner !== null) destination = inner;
              } else {
                selector = '#' + section.id;
              }
              try {
                if (self.isSectionInnerHTML(parsedState.sections[section.section], selector)) {
                  destination.innerHTML = self.getSectionInnerHTML(parsedState.sections[section.section], selector);
                  if (section.show_hidden) {
                    var hidden = destination.querySelector('.hidden[data-render-only]');
                    if (hidden) hidden.classList.toggle('hidden');
                  }
                  var showOnScroll = destination.querySelector('.show-on-scroll');
                  if (showOnScroll) showOnScroll.classList.toggle('is-visible');
                }
              } catch (e) {
                console.warn('[cart-fix] section render skipped:', section.id, e);
              }
            });
          }
        }
      });

      try {
        this.currentLineCount = document.querySelector('cart-items').querySelectorAll('[name="updates[]"]').length;
        document.querySelector('cart-items').classList.toggle('is-empty', this.currentLineCount === 0);
      } catch (e) {}
    };

    Cls.prototype.__patchedRender = true;
    console.log('[cart-fix] renderContents patched');
  }

  function tryPatch() {
    patchMinicartLineItem();
    patchCartItemsRender();
  }

  tryPatch();
  document.addEventListener('DOMContentLoaded', tryPatch);
  setTimeout(tryPatch, 1000);
  setTimeout(tryPatch, 3000);
})();